import React from "react";
import { withStyles } from "@material-ui/styles";
import { get, map, size, filter, debounce } from "lodash";

import Grid from "@material-ui/core/Grid";

import BreadcrumbItem from "./BreadcrumbItem";
import BreadcrumbSeparator from "./BreadcrumbSeparator";
import BreadcrumbEllipse from "./BreadcrumbEllipse";

const styles = {
  container: {
    maxWidth: "60vw",
    maxHeight: "44px",
    flexWrap: "nowrap",
  },
};

const Breadcrumb = (props) => {
  const { classes, breadcrumb } = props;
  const [overflownBy, setOverflownBy] = React.useState(false);

  const breadcrumbContainer = document.getElementById("breadcrumb-container");

  const itemMaxWidth = 160;

  const path = filter(
    get(breadcrumb, ["path"]),
    (b) => get(b, ["display"]) !== false
  );

  React.useEffect(() => {
    if (breadcrumbContainer) {
      handleResize(size(path) * itemMaxWidth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breadcrumbContainer, path]);

  const handleResize = (
    contentWidth = get(breadcrumbContainer, ["scrollWidth"]),
    containerWidth = get(breadcrumbContainer, ["clientWidth"])
  ) => {
    setOverflownBy(
      contentWidth > containerWidth ? contentWidth - containerWidth : false
    );
  };

  const debouncedHandleResize = debounce((a, b) => handleResize(a, b), 200);

  React.useEffect(() => {
    const resize = () => {
      const bc = document.getElementById("breadcrumb-container");
      debouncedHandleResize(
        size(path) * itemMaxWidth,
        get(bc, ["clientWidth"])
      );
    };
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  const collapsedItemsNb = Math.round(overflownBy / 160);

  return (
    <Grid container className={classes.container} id="breadcrumb-container">
      {map(path, (b, index) => (
        <React.Fragment key={index}>
          {collapsedItemsNb > 0 && index === 1 ? (
            <>
              <BreadcrumbEllipse
                items={filter(path, (b, i) => i >= 1 && i <= collapsedItemsNb)}
              />
              <BreadcrumbSeparator />
            </>
          ) : collapsedItemsNb > 0 &&
            index > 1 &&
            index <= collapsedItemsNb ? null : (
            <>
              <BreadcrumbItem
                item={b}
                pathSize={size(path)}
                itemMaxWidth={itemMaxWidth}
              />
              {index < size(path) - 1 && <BreadcrumbSeparator />}
            </>
          )}
        </React.Fragment>
      ))}
      {get(breadcrumb, ["picture"]) && (
        <Grid item style={{ display: "flex", alignItems: "center" }}>
          <img
            src={breadcrumb.picture}
            alt="pict"
            style={{ maxHeight: "20px", marginLeft: "12px" }}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default withStyles(styles)(Breadcrumb);

/**
 * Breadcrumb structure:
 * [
 *  {
 *    name: string,
 *    url: optional url string (display a link),
 *    display: boolean,
 *    subName: optional sub name (below the main name)
 *  },
 *  ...
 * ]
 */
